import api from './api';

export interface Team {
  id: string;
  name: string;
  description?: string;
  leaderId?: string;
  leaderName?: string;
  memberCount: number;
  activeProjectsCount: number;
  createdAt: string;
  updatedAt?: string;
}

export interface TeamDetails {
  id: string;
  name: string;
  description?: string;
  leaderId?: string;
  leaderName?: string;
  createdAt: string;
  updatedAt?: string;
  members: TeamMember[];
  projects: TeamProject[];
}

export interface TeamMember {
  id: string;
  userId: string;
  userFullName: string;
  userEmail: string;
  userProfilePicture?: string;
  role: string;
  joinedAt: string;
  isActive: boolean;
}

export interface TeamProject {
  projectId: string;
  projectName: string;
  projectKey: string;
  assignedAt: string;
}

export interface CreateTeamRequest {
  name: string;
  description?: string;
  leaderId?: string;
}

export interface UpdateTeamRequest {
  name: string;
  description?: string;
  leaderId?: string;
}

export interface AddTeamMemberRequest {
  userId: string;
  role: string;
}

const teamService = {
  async getAllTeams(): Promise<Team[]> {
    const response = await api.get('/teams');
    return response.data;
  },

  async getTeamById(id: string): Promise<TeamDetails> {
    const response = await api.get(`/teams/${id}`);
    return response.data;
  },

  async createTeam(team: CreateTeamRequest): Promise<Team> {
    const response = await api.post('/teams', team);
    return response.data;
  },

  async updateTeam(id: string, team: UpdateTeamRequest): Promise<Team> {
    const response = await api.put(`/teams/${id}`, team);
    return response.data;
  },

  async deleteTeam(id: string): Promise<void> {
    await api.delete(`/teams/${id}`);
  },

  async getTeamMembers(teamId: string): Promise<TeamMember[]> {
    const response = await api.get(`/teams/${teamId}/members`);
    return response.data;
  },

  async addTeamMember(teamId: string, member: AddTeamMemberRequest): Promise<TeamMember> {
    const response = await api.post(`/teams/${teamId}/members`, member);
    return response.data;
  },

  async removeTeamMember(teamId: string, userId: string): Promise<void> {
    await api.delete(`/teams/${teamId}/members/${userId}`);
  },
};

export default teamService;
